export default __webpack_public_path__ + "static/media/mountains.9f4b4de0.jpg";